import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import QILogo from "../assets/images/qitechLogo04.png";

export const TopBar = (props) => {

    const { onToggleSidebar } = props

    return (
        <div className="top-bar">
            <button
                type="button"
                className="top-bar__hamburger"
                aria-label="Abrir menu"
                onClick={onToggleSidebar}
            >
                <MenuIcon style={{ width: "2.4rem", height: "2.4rem" }} />
            </button>
            <img
                src={QILogo}
                alt="QILogo"
            ></img>
            <div className="top-bar__text">QI Sign</div>
        </div>
    )
}